import API from '@/api';

const GET_COURSES = 'GET_COURSES';
const GET_COURSES_SUCCESS = 'GET_COURSES_SUCCESS';
const GET_COURSES_FAILED = 'GET_COURSES_FAILED';

const SHOW_COURSE = 'SHOW_COURSE';
const SHOW_COURSE_SUCCESS = 'SHOW_COURSE_SUCCESS';
const SHOW_COURSE_FAILED = 'SHOW_COURSE_FAILED';

const RESET_COURSE_DETAILS = 'RESET_COURSE_DETAILS';

const genericCourseImg =
  'https://e6golf-assets.imgix.net/courses/images/generic_course_placeholder.png';

// Enabled the module to be namespaced
const namespaced = true;

// Course initial state
const state = {
  all: [],
  courseDetails: {},
  loadingCourses: false,
  loadingCourse: false,
};

// Course getters
const getters = {
  // courseList returns a list of courses
  courseList: (state) => {
    return state.all;
  },

  // courseDetails returns details of the course in question
  courseDetails: (state) => {
    return state.courseDetails;
  },

  loading: (state) => {
    return state.loadingCourse;
  },

  loadingCourses: (state) => {
    return state.loadingCourses;
  },
};

// Course actions
const actions = {
  //* all fetches the courses list from the API
  async fetchAllCourses({ commit }, payload = {}) {
    let response;

    commit(GET_COURSES);

    try {
      response = await API.courses.list(payload);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(GET_COURSES_FAILED);
        reject(response);
      } else {
        commit(GET_COURSES_SUCCESS, response.data);
        // Return GET data  within promise
        resolve(response.data);
      }
    });
  },

  //* show fetches the courses list from the API
  async showCourse({ commit }, id) {
    let response;

    commit(SHOW_COURSE);

    try {
      response = await API.courses.show(id);
    } catch (err) {
      response = err;
    }

    return new Promise((resolve, reject) => {
      if (response.status >= 400) {
        commit(SHOW_COURSE_FAILED);
        reject(response);
      } else {
        commit(SHOW_COURSE_SUCCESS, response.data);
        // Return GET data  within promise
        resolve(response.data);
      }
    });
  },

  //* resetSelectedCourse clears the selected course info from state
  async resetSelectedCourse({ commit }) {
    commit(RESET_COURSE_DETAILS);
  },
};

// Course mutations
const mutations = {
  [GET_COURSES](state) {
    state.loadingCourses = true;
  },

  [GET_COURSES_SUCCESS](state, courses) {
    state.all = courses;
    state.loadingCourses = false;
  },

  [GET_COURSES_FAILED](state) {
    state.loadingCourses = false;
  },

  [SHOW_COURSE](state) {
    state.loadingCourse = true;
  },

  [SHOW_COURSE_SUCCESS](state, course) {
    // Compensate for apex using 1 based holes and missing topViewImages
    const updatedHoles = course?.holes?.map((hole) => {
      const match = hole?.name?.match(/^Hole (\d+)$/);
      if (!hole?.topViewURL?.includes('uploads')) {
        hole.topViewURL = `${genericCourseImg}?fit=crop`;
      }

      return {
        ...hole,
        apexHoleNumber: match ? parseInt(match[1], 10) : null,
      };
    });
    course.holes = updatedHoles;

    state.courseDetails = { ...course };
    state.loadingCourse = false;
  },

  [SHOW_COURSE_FAILED](state) {
    state.loadingCourse = false;
  },

  [RESET_COURSE_DETAILS](state) {
    state.courseDetails = {};
  },
};

export default {
  namespaced,
  state,
  getters,
  actions,
  mutations,
};
